// extracted by mini-css-extract-plugin
export default {"listItemText":"DynamicSegmentListItem_listItemText__s9PW0","listItemDependencyPill":"DynamicSegmentListItem_listItemDependencyPill__u41z6"};